// Copyright (c) Move Closer 2023.

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export const wishlist = {
  initWishlist: true
}
